import { AdminApproveBorrowFormContainer } from "../../containers/borrowSystem/AdminApproveBorrowFormContainer";

export function AdminApproveBorrowFormPage() {
    return (
        <AdminApproveBorrowFormContainer />
    )
}
